import React, { useState } from "react";
import { readWhatsAppPhoneEntry } from "../../services/supabase/edge-functions/_shared/whatsappPhone";

export default function WhatsAppNumberConnection({ currentPhone, connectionKind, busy, phase, ready, message, onConnect, sdkStatus = "ready", sdkError = "", loadFailed = false, onRetry }) {
  const [callingCode, setCallingCode] = useState("+54");
  const [number, setNumber] = useState("");
  const [error, setError] = useState("");
  const linked = connectionKind === "business_token";
  const canConnect = ready === true && sdkStatus === "ready" && !busy;
  const preparing = ready == null || (ready === true && ["idle", "loading"].includes(sdkStatus));

  const submit = (event) => {
    event.preventDefault();
    if (!canConnect) return;
    try {
      const entry = readWhatsAppPhoneEntry(callingCode, number);
      setError("");
      onConnect(entry);
    } catch (validationError) {
      setError(validationError.message);
    }
  };

  return (
    <form onSubmit={submit} style={styles.form}>
      {currentPhone ? (
        <div style={styles.current}>
          <strong>{linked ? "Numero vinculado a este local" : "Numero configurado anteriormente"}</strong>
          <span style={styles.phone}>{currentPhone}</span>
          {connectionKind === "revoked" || connectionKind === "expired" ? <span>Hace falta volver a autorizar la conexion.</span> : null}
        </div>
      ) : null}
      <div style={styles.fields}>
        <label style={styles.label}>
          Pais
          <input aria-label="Codigo de pais" autoComplete="tel-country-code" type="tel" inputMode="tel" maxLength={4} value={callingCode} onChange={(event) => setCallingCode(event.target.value)} disabled={busy} style={styles.input} />
        </label>
        <label style={styles.label}>
          WhatsApp Business del local
          <input aria-label="WhatsApp Business del local" aria-describedby="whatsapp-number-error" aria-invalid={Boolean(error)} autoComplete="tel-national" type="tel" inputMode="tel" maxLength={30} value={number} onChange={(event) => setNumber(event.target.value)} placeholder="1112345678" disabled={busy} style={styles.input} />
        </label>
      </div>
      {error ? <span id="whatsapp-number-error" role="alert" style={styles.error}>{error}</span> : null}
      <button type="submit" disabled={!canConnect} style={{ ...styles.button, opacity: canConnect ? 1 : 0.65 }}>
        {busy ? (phase === "saving" ? "Vinculando numero..." : "Esperando confirmacion de Meta...") : preparing ? "Preparando conexion con Meta..." : "Vincular WhatsApp"}
      </button>
      {ready === false && message ? <span role="status" style={styles.error}>{message}</span> : null}
      {sdkError ? <span role="alert" style={styles.error}>{sdkError}</span> : null}
      {(loadFailed || sdkStatus === "error") && onRetry ? (
        <button type="button" onClick={onRetry} disabled={busy} style={{ ...styles.button, background: "#fff", color: "#172b4d", border: "1px solid #b4c5df" }}>Reintentar carga de Meta</button>
      ) : null}
      <small style={styles.disclosure}>La vinculacion requiere que el titular autorice su numero en Meta.</small>
    </form>
  );
}

const styles = {
  form: { display: "grid", gap: 14, margin: "18px 0 22px", minWidth: 0 },
  current: { display: "grid", gap: 5, borderLeft: "3px solid #64748b", paddingLeft: 12, color: "#334155", fontSize: 14 },
  phone: { fontWeight: 700, overflowWrap: "anywhere" },
  fields: { display: "grid", gridTemplateColumns: "80px minmax(0, 1fr)", gap: 10 },
  label: { display: "grid", alignContent: "end", gap: 7, minWidth: 0, fontSize: 14, color: "#172b4d", fontWeight: 600 },
  input: { boxSizing: "border-box", width: "100%", minWidth: 0, height: 48, padding: "10px 12px", border: "1px solid #b4c5df", borderRadius: 8, fontSize: 16, color: "#172b4d", background: "#fff" },
  button: { width: "100%", minHeight: 48, padding: "12px 16px", border: 0, borderRadius: 8, color: "#fff", background: "#b83b05", fontSize: 16, fontWeight: 700, whiteSpace: "normal", cursor: "pointer" },
  disclosure: { color: "#475569", lineHeight: 1.5 },
  error: { color: "#a11919", fontSize: 14, lineHeight: 1.5 },
};
